import $ from 'jquery';

class Navigation {
  constructor() {
    this.header = $('.js-header');
    this.nav = $('.js-nav');
    this.mainNav = $('.js-main-nav');
    this.navToggler = $('.js-nav-toggler');
    this.mainNavLink = this.mainNav.find('.js-main-nav-link');
    this.mainNavMarker = this.mainNav.find('.js-main-nav-marker');
    this.headerButtons = $('.js-header-buttons');

    this.verticalLeft = -1;

    this.mobileNavToggler();
    this.mobileNavDropdown();
    this.headerButtonsAnchorHandler();

    let debounce;
    $(window).on('load resize', () => {
      clearTimeout(debounce);

      debounce = setTimeout(() => {
        this.activeLine();
      }, 50);
    });
  }

  activeLine() {
    const isTablet = $(window).width() < 1024 && $(window).width() > 767;
    const isDesktop = $(window).width() > 1023;

    if (!this.mainNavMarker.length || (!isTablet && !isDesktop)) {
      return;
    }

    const activeItem = this.mainNav.find('.current-menu-item');
    const firstItem = this.mainNav.find('.js-main-nav-item').first();

    if (!activeItem.length) {
      if (firstItem.length) {
        const props = {
          width: 0,
          height: 0,
        };

        if (isDesktop) {
          props.left =
            firstItem.position().left +
            parseInt(firstItem.css('padding-left'), 10);
          props.top = 'auto';
        } else {
          props.left = this.verticalLeft;
          props.top = firstItem.position().top;
        }

        this.mainNavMarker.css(props);
      }
    } else {
      const props = {};

      if (isDesktop) {
        props.width = activeItem.width();
        props.left =
          activeItem.position().left +
          parseInt(activeItem.css('padding-left'), 10);
        props.top = 'auto';
      } else {
        props.left = this.verticalLeft;
        props.width = 0;
        props.height = activeItem.height();
        props.top = activeItem.position().top;
      }

      this.mainNavMarker.css(props);
    }

    this.mainNav.find('.js-main-nav-link').off('mouseenter focus');
    this.mainNav.find('.js-main-nav-link').on('mouseenter focus', e => {
      const self = $(e.currentTarget);
      const props = {};

      if (isDesktop) {
        props.width = self.width();
        props.left =
          self.parent().position().left +
          parseInt(self.parent().css('padding-left'), 10);
        props.top = 'auto';
      } else {
        props.left = this.verticalLeft;
        props.width = 0;
        props.top = self.parent().position().top;
      }

      this.mainNavMarker.stop().animate(props);
    });

    this.mainNav.find('.js-main-nav-link').off('mouseleave blur');
    this.mainNav.find('.js-main-nav-link').on('mouseleave blur', () => {
      const props = {};

      if (isDesktop) {
        props.width = activeItem.length ? activeItem.width() : 0;
        props.left = activeItem.length
          ? activeItem.position().left +
            parseInt(activeItem.css('padding-left'), 10)
          : firstItem.position().left +
            parseInt(firstItem.css('padding-left'), 10);
        props.top = 'auto';
      } else {
        props.left = this.verticalLeft;
        props.width = 0;
        props.top = activeItem.length
          ? activeItem.position().top
          : firstItem.position().top;
      }

      this.mainNavMarker.stop().animate(props);
    });
  }

  mobileNavToggler() {
    if (this.navToggler.length) {
      this.navToggler.on('click', e => {
        const toggler = $(e.currentTarget);
        const target = toggler.data('target');
        const nav = this.header.find(`#${target}`).parent();

        toggler
          .toggleClass('is-active')
          .attr('aria-expanded', toggler.hasClass('is-active'));

        if (nav.length) {
          nav.toggleClass('is-open');
          this.header.toggleClass('is-active');

          // On mobile, when main nav is open, add the secondary nav to it
          // if (nav.hasClass('is-open') && $(window).width() <= 1023) {
          //   // Move secondary nav inside the open mobile menu if it's not already there
          //   if (!nav.find('.js-header-buttons').length) {
          //     // Clone the secondary nav and append it to the main nav's container
          //     this.headerButtons.clone(true).appendTo(nav);
          //   }
          // }

          if (!nav.find('.js-nav-toggler').length) {
            toggler
              .clone()
              .css({
                top: toggler.position().top,
                right: 10,
              })
              .addClass('is-active')
              .prependTo(nav);
          }

          if (nav.find('.c-logo').length) {
            nav.find('.c-logo').css({
              top: toggler.position().top,
              left: 24,
            });
          }

          nav
            .find('.js-nav-toggler')
            .off('click')
            .on('click', () => {
              nav.removeClass('is-open');
              toggler.removeClass('is-active');
            });
        }
      });
    }
  }

  mobileNavDropdown() {
    this.mainNavLink.on('click', e => {
      const target = $(e.target);

      if (
        this.navToggler.is(':visible') &&
        (target.hasClass('js-caret') || target.closest('.js-caret').length)
      ) {
        e.preventDefault();
        const dropdown = target
          .closest('.js-main-nav-item')
          .find('.js-main-nav-dropdown')
          .first();

        if (dropdown.length) {
          // if more dropdown levels show all on opening the top one
          const dropdowns = dropdown.find('.js-main-nav-dropdown');
          if (dropdowns.length) {
            dropdowns.show();
          }

          this.mainNav
            .find('.js-main-nav-dropdown')
            .not(dropdown)
            .slideUp();
          dropdown.slideToggle();
        }
      }
    });
  }

  headerButtonsAnchorHandler() {
    if (!this.headerButtons.length) {
      return;
    }

    const buttons = this.headerButtons.find('.c-btn');

    buttons.on('click', e => {
      const target = $(e.target);
      let href = target.attr('href');

      if (href.includes('localhost')) {
        href = `http:${href}`;
      }

      const url = new URL(href);

      if (url.hash.substring(0, 1) === '#') {
        const section = $(url.hash);

        if (section.length) {
          e.preventDefault();

          if (this.navToggler.hasClass('is-active')) {
            this.navToggler.trigger('click');
          }

          $('body, html')
            .stop()
            .animate(
              {
                scrollTop: section.offset().top + 100,
              },
              500,
            );
        }
      }
    });
  }
}

export default new Navigation();



// WEBPACK FOOTER //
// ./src/scripts/modules/main-nav.js